import React from "react";

export function Skeleton({ className = "" }) {
  return <div className={`skeleton ${className}`} aria-hidden="true" />;
}

function CardRowSkeleton() {
  return (
    <div className="rounded-2xl bg-[var(--surface)] border border-[var(--line)] shadow-[0_2px_10px_rgba(26,28,26,0.04)] p-5">
      <div className="flex items-start justify-between gap-6">
        <div className="min-w-0 flex-1 space-y-2.5">
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-3 w-1/2" />
          <Skeleton className="h-7 w-44 mt-1 rounded-full" />
        </div>
        <div className="flex gap-1.5 shrink-0">
          <Skeleton className="h-5 w-16 rounded-full" />
          <Skeleton className="h-5 w-14 rounded-full" />
        </div>
      </div>
      <div className="mt-4 pt-3.5 border-t border-[var(--line2)] flex items-center justify-between">
        <Skeleton className="h-6 w-20 rounded-full" />
        <Skeleton className="h-6 w-24 rounded-full" />
      </div>
    </div>
  );
}

export function InboxSkeleton() {
  return (
    <div className="space-y-8" data-testid="inbox-skeleton">
      <div className="space-y-2">
        <Skeleton className="h-5 w-28" />
      </div>
      <div className="space-y-3">
        <CardRowSkeleton />
        <CardRowSkeleton />
        <CardRowSkeleton />
      </div>
    </div>
  );
}

export function TimelineSkeleton() {
  return (
    <div className="relative pl-6 space-y-6" data-testid="timeline-skeleton">
      <div className="absolute left-[7px] top-2 bottom-2 w-px bg-[var(--line)]" />
      {[0, 1, 2, 3].map((i) => (
        <div key={i} className="relative">
          <span className="absolute -left-[22px] top-1.5 h-3.5 w-3.5 rounded-full ring-4 ring-[var(--bg)] bg-[var(--line)]" />
          <div className="rounded-2xl bg-[var(--surface)] border border-[var(--line)] shadow-[0_2px_10px_rgba(26,28,26,0.04)] p-5 space-y-2.5">
            <div className="flex items-center justify-between">
              <Skeleton className="h-3 w-20" />
              <Skeleton className="h-3 w-16" />
            </div>
            <Skeleton className="h-4 w-2/3" />
            <Skeleton className="h-3 w-1/3" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function SettingsSkeleton() {
  return (
    <div className="space-y-6" data-testid="settings-skeleton">
      <div className="rounded-2xl bg-[var(--surface)] border border-[var(--line)] shadow-[0_2px_10px_rgba(26,28,26,0.04)] p-6 sm:p-7 space-y-4">
        <Skeleton className="h-4 w-40" />
        <div className="flex items-center gap-3">
          <Skeleton className="h-9 w-9 rounded-full" />
          <div className="space-y-1.5">
            <Skeleton className="h-3.5 w-28" />
            <Skeleton className="h-3 w-40" />
          </div>
        </div>
        <Skeleton className="h-10 w-48 rounded-xl" />
      </div>
      <div className="rounded-2xl bg-[var(--surface)] border border-[var(--line)] shadow-[0_2px_10px_rgba(26,28,26,0.04)] p-6 sm:p-8 space-y-6">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="flex items-center justify-between gap-6">
            <div className="space-y-2 flex-1">
              <Skeleton className="h-4 w-40" />
              <Skeleton className="h-3 w-56" />
            </div>
            <Skeleton className="h-7 w-12 rounded-full" />
          </div>
        ))}
      </div>
    </div>
  );
}
